export var DiscountCalculationType;
(function(DiscountCalculationType) {
    DiscountCalculationType[/**
     * Represents a special discounted price to be applied.
     */ "SpecialPrice"] = "SpecialPrice";
    DiscountCalculationType[/**
     * Represents a percentage off the default price.
     */ "PercentageOff"] = "PercentageOff";
    DiscountCalculationType[/**
     * Represents a particular value off the default price.
     */ "PriceOff"] = "PriceOff";
})(DiscountCalculationType || (DiscountCalculationType = {}));

//# sourceMappingURL=discount-calculation-type.js.map